import React from 'react';
import styled from 'styled-components';
import { css } from '/imports/ui/css';
import { Loading } from '/imports/ui/Loading';

interface LoadingFlexProps {
  caption?: string;
  className?: string;
}

const LoadingFlexStyled = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  background-color: ${css.backgroundColor};
`;

/** Flex container that centers a Loading spinner with an optional caption. */
export const LoadingFlex = (props: LoadingFlexProps) => (
  <LoadingFlexStyled className={`loading-flex ${props.className || ''}`}>
    <Loading caption={props.caption} />
  </LoadingFlexStyled>
);